import { render } from "./SimpleTree.vue?vue&type=template&id=32ab10ac&scoped=true"
import script from "./SimpleTree.vue?vue&type=script&lang=js"
export * from "./SimpleTree.vue?vue&type=script&lang=js"

import "./SimpleTree.vue?vue&type=style&index=0&id=32ab10ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32ab10ac"

export default script